import React from 'react';
import { failures, sosFramework } from '../data/ebook';
import { Section } from './Section';
export function Problem() {
  return <Section id="problema" className="bg-white" data-id="element-205" data-mp="2peyxyf8jfqeo">
      <div className="grid gap-14 lg:grid-cols-[0.9fr_1.1fr] lg:gap-20" data-id="element-206" data-mp="2bfzle5yav1yv">
        <div data-id="element-207" data-mp="2bhtvsqby3bop">
          <p className="text-xs font-semibold uppercase tracking-[0.22em] text-sage-dark" data-id="element-208" data-mp="2gesp56nsbelu">
            El diagnóstico
          </p>
          <h2 className="mt-5 font-display text-4xl font-light leading-tight text-ink sm:text-5xl" data-id="element-209" data-mp="21po3ffhs6s8z">
            Te levantas plana y a las 4 de la tarde pareces de cuatro meses.
          </h2>
          <p className="mt-6 text-lg leading-relaxed text-muted" data-id="element-210" data-mp="1sprkzvlzipmd">
            La grasa no aparece y desaparece en 8 horas. Lo que tienes es una respuesta
            inflamatoria: tu cuerpo retiene líquidos para apagar un incendio interno.
          </p>
          <p className="mt-5 border-l-2 border-sage pl-5 font-display text-2xl leading-snug text-ink" data-id="element-211" data-mp="1it52hdh4sani">
            «La inflamación es la forma en que tu cuerpo dice: no puedo procesar esto.»
          </p>
        </div>

        <div data-id="element-212" data-mp="oau80fz77k94">
          <h3 className="text-sm font-semibold uppercase tracking-[0.16em] text-ink" data-id="element-213" data-mp="obdg74z1qu9y">
            El marco de identificación S.O.S.
          </h3>
          <dl className="mt-6 divide-y divide-line border-y border-line" data-id="element-214" data-mp="12a3geth5xa2j">
            {sosFramework.map(item => <div key={item.name} className="flex gap-6 py-6" data-id="element-215" data-mp="x9frcdchv3ay">
                <span className="w-8 shrink-0 font-display text-4xl leading-none text-sage" aria-hidden="true" data-id="element-216" data-mp="9mr3zc4puimy">
                  {item.letter}
                </span>
                <div data-id="element-217" data-mp="jd28azsbatud">
                  <dt className="text-base font-semibold text-ink" data-id="element-218" data-mp="jdlmq6ir703n">{item.name}</dt>
                  <dd className="mt-1.5 text-[15px] leading-relaxed text-muted" data-id="element-219" data-mp="eixxu6ju83oj">
                    {item.question}{' '}
                    <span className="font-medium text-ink" data-id="element-220" data-mp="3i1r8aahbkceh">{item.verdict}</span>
                  </dd>
                </div>
              </div>)}
          </dl>
        </div>
      </div>

      <div className="mt-20 border-t border-line pt-14" data-id="element-221" data-mp="1qxppep9eekh6">
        <h3 className="font-display text-3xl font-light text-ink sm:text-4xl" data-id="element-222" data-mp="1qw4tav7fqth7">
          Por qué lo que intentaste antes no funcionó
        </h3>
        <ol className="mt-8 grid gap-x-10 gap-y-8 sm:grid-cols-3" data-id="element-223" data-mp="20niwpe2icdfm">
          {failures.map((failure, index) => <li key={failure.title} className="flex flex-col" data-id="element-224" data-mp="130a5r3jqmc68" data-mpi={index}>
              <span className="font-display text-2xl text-sand" aria-hidden="true" data-id="element-225" data-mp="1323gatxh1gji">
                0{index + 1}
              </span>
              <h4 className="mt-2 text-base font-semibold text-ink" data-id="element-226" data-mp="1cxew7fkm8tsu">{failure.title}</h4>
              <p className="mt-2 text-[15px] leading-relaxed text-muted" data-id="element-227" data-mp="1gz9yonea9d87">{failure.body}</p>
            </li>)}
        </ol>
      </div>
    </Section>;
}